import {IndustryGroup} from "../types/IndustryGroup";

export const IndustryGroupTranslateFilter = "industryGroupTranslate";

export function industryGroupTranslateFilter() {
    return function(group: IndustryGroup | null): string | null {
        if (group == null) {
            return null;
        } else {
            return "gics." + group;
        }
    }
}